import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  listMeeting: [],
  filterData: {
    meeting_id: null
  },
  loading: false,
  teacherDashboardOverview: null,
  dashboardSubmoduleStudentStatus:null,
  moduleOptions:[],
  assignmentOptions:[],
  classFilter:null,
  moduleFilter:null,
  assignmentFilter:null,
};

const teacherDashboardSlice = createSlice({
    name: 'teacherDashboard',
    initialState,
    reducers: {
      setLoading(state, action) {
          state.loading = action.payload;
      },
      setFilterData(state, action) {
        state.filterData = action.payload;
      },
      setListMeeting(state, action) {
        state.listMeeting = action.payload;
      },
      resetStudentDashboardData(state) {
          state.listMeeting = initialState.listMeeting,
          state.loading = initialState.loading,
          state.filterData = initialState.filterData
      },
      setTeacherDashboardOverview(state, action) {
        state.teacherDashboardOverview = action.payload;
      },
      setDashboardSubmoduleStudentStatus(state, action) {
        state.dashboardSubmoduleStudentStatus = action.payload;
      },
      setClassFilter(state, action) {
        state.classFilter = action.payload;
      },
      setModuleFilter(state, action) {
        state.moduleFilter = action.payload;
      },
      setAssignmentFilter(state, action) {
        state.assignmentFilter = action.payload;
      },
      setModuleOptions(state, action) {
        state.moduleOptions = action.payload;
      },
      setAssignmentOptions(state, action) {
        state.assignmentOptions = action.payload;
      },
    },
});

export const {
    setLoading,
    setFilterData,
    setListMeeting,
    setTeacherDashboardOverview,
    setDashboardSubmoduleStudentStatus,
    setClassFilter,
    setModuleFilter,
    setAssignmentFilter,
    setModuleOptions,
    setAssignmentOptions
} = teacherDashboardSlice.actions;

export default teacherDashboardSlice.reducer;